<template>
    <div>
        <div
            class="inline-block mt-1 px-4 py-2 cursor-pointer text-lg border-solid border rounded font-bold border-gray-300 hover:bg-white hover:text-green-700 hover:border-green-700"
            @click="showReviews = !showReviews"
        >
            View {{ reviewCount }} {{ reviewsPlural }} - {{ reviewAverage }}/5 Average Rating
        </div>
        <div
            v-if="showReviews"
            @click.self="showReviews = false"
            class="fixed z-50 pt-16 left-0 top-0 w-full h-full overflow-auto bg-gray-900 bg-opacity-50"
        >
            <!-- Modal content -->
            <div
                class="opacity-100 bg-bluebg mx-auto py-4 px-6 rounded shadow-lg w-11/12 md:max-w-5xl"
            >
                <div class="flex justify-between items-center pb-3">
                    <div class="inline-block">
                        <div class="sm:flex">
                            <p class="mt-4 ml-4 text-2xl font-bold">
                                {{ reviewCount }} {{ reviewsPlural }} -
                                {{ reviewAverage }}/5 Average Rating
                            </p>

                        </div>
                        <AllReviewsRatingComponent
                            v-if="Object.keys(reviewCategories).length !== 0"
                            class="ml-4"
                            :reviews="reviewCategories"
                        />
                    </div>
                    <div
                        @click="showReviews = false"
                        class="cursor-pointer mb-auto"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            class="fill-current text-black"
                        >
                            <path
                                d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"
                            ></path>
                        </svg>
                    </div>
                </div>
                <div v-for="item in reviews" class="bg-white p-4 my-6 shadow">
                    <h4 class="inline font-nova-regular text-lg">
                        {{ item.r_title }}
                    </h4>
                    <div class="font-nova-regular text-sm">
                        By {{ item.r_customer }} on {{ item.r_created }}
                    </div>
                    <p>{{ item.r_review }}</p>
                    <div
                        v-if="item.r_response"
                        class="bg-white border p-4 my-3 mt-5 shadow-md w-auto"
                    >
                        <p class="text-black-700 text-xs mb-2">
                            <span class="font-bold">Owner response </span>
                            <span
                            >on
                                {{ formatDate(item.r_response_created) }}</span
                            >
                        </p>
                        <p class="text-sm">{{ item.r_response }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import AllReviewsRatingComponent from "./AllReviewsRatingComponent.vue";
import {format} from "date-fns";

export default {
    name: "ReviewsComponent",
    props: [
        "reviewCount",
        "reviews",
        "reviewAverage",
        "reviewCategories",
        "property_id"
    ],
    components: {AllReviewsRatingComponent},
    methods: {
        formatDate(date) {
            return format(date, "DD-MMM-YYYY");
        }
    },
    computed: {
        reviewsPlural() {
            return this.reviewCount > 1 ? "Reviews" : "Review";
        }
    },
    data: function () {
        return {
            showReviews: false,
            showCategoriesReview: false
        };
    }
};
</script>
